import { styled, Box, Button as MuiButton } from "@mui/material";
import { ENV_COLORS } from "../../../styles/theme";

export const Button = styled(MuiButton)(() => ({
    backgroundColor: ENV_COLORS[process.env.REACT_APP_ENV] || ENV_COLORS.default,
    color: "#fff", // optional text color for contrast
    "&:hover": {
    backgroundColor:
      ENV_COLORS[process.env.REACT_APP_ENV] || ENV_COLORS.default
  }
}));
